package top.wcpe.allincore.ui.runtime.ir.call

import top.wcpe.allincore.dsl.ir.expr.ExprNode
import top.wcpe.allincore.dsl.ir.expr.StmtNode

/**
 * 局部 fun 运行期值（C4）。
 *
 * 与 [LambdaValue] 的关键差异：
 * - lambda：按值闭包——构造时拍快照，调用时把 captured snapshot 与参数一起 push 到新帧。
 * - local fun：按引用闭包——不持有 captured 快照，调用时直接在当前 EvalContext 的
 *   var 帧栈上 push 参数帧；body 内对外层 var 的查找/赋值穿透写回原栈。
 *
 * 该值仅在声明所在的 callable 体生命周期内有效；逃逸到外部（如赋给 state 后跨帧调用）
 * 行为未定义——PLAN 明确不在 C4 范围内处理。
 *
 * M5-b：新增 `defaults` 字段，含义与 [LambdaValue.defaults] 一致。
 */
data class LocalFunValue(
    val name: String,
    val params: List<String>,
    val body: List<StmtNode>,
    // 元素可空：形参无默认值时对应位置为 null（与 IR StmtNode.LocalFunDecl.defaults 对齐）。
    val defaults: List<ExprNode?> = emptyList(),
) {
    init {
        require(defaults.isEmpty() || defaults.size == params.size) {
            "local fun '$name' defaults 长度与 params 不一致"
        }
    }

    override fun toString(): String = "LocalFun(${name}$params)"
}
